export const INITIALIZED = 'INITIALIZED';
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const FORBIDDEN = 'FORBIDDEN';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const TOKEN_HEADER = 'X-Auth-Token';
export const REFRESH_TOKEN_HEADER = 'X-Auth-Token-Refresh';
